export default __webpack_public_path__ + "static/media/cphate.41a8feb0.svg";